import { getUserRole as getRoleFromCache } from "src/utils/getUserInfo";

/** Get user role (groupName) from cached /auth/me data. Sync; may return null if cache not yet loaded. */
export const getUserRole = () => getRoleFromCache();